export default {
  title: 'Kiireinen tila',
  form: {
    has_busy_mode: {
      label: 'Kiireinen tila',
    },
    busy_mode_minutes: {
      label: 'Kuinka paljon aikaa lisätään tavalliseen valmisteluaikaan?',
      options: {
        10: '10 min',
        15: '15 min',
        20: '20 min',
        25: '25 min',
        30: '30 min',
        45: '45 min',
        60: '1 tunti',
      },
    },
  },
  buttons: {
    save: 'Tallenna',
  },
  toasts: {
    failed_to_save_changes: 'Muutosten tallennus epäonnistui',
    changes_got_saved: 'Muutokset tallennettu onnistuneesti',
  },
};
